/**
 * Logic Necessary for the Bio Modal
 * Author: Imarc 2019
 */

// Dependencies
import '../polyfills/prepend';

// DOM Nodes
const bioModalLinks = [...document.querySelectorAll('.js-bioModalLink')];
const bioModal = document.querySelector('.js-bioModal');
const bioContainer = bioModal.querySelector('.js-bioContainer');
const bioModalClose = bioModal.querySelector('.js-bioModalClose');
const html = document.querySelector('html');

// For Brevity
const raf = window.requestAnimationFrame;

bioModalLinks.forEach(function addClickEventToBioModalLink(bioModalLink) {
    bioModalLink.addEventListener('click', event => {
        event.preventDefault();
        const currentBioDataName = bioModalLink.dataset.bio;
        const associatedBioNode = document.querySelector(
            `.js-bio[data-bio="${currentBioDataName}"] .js-bioContent`
        );
        html.classList.add('scroll-lock');

        raf(() => {
            bioContainer.prepend(associatedBioNode.cloneNode(true));

            raf(() => {
                bioModal.classList.add('-active');
                raf(() => {
                    bioModal.classList.add('-revealed');
                });
            });
        });
    });
});

bioModalClose.addEventListener('click', () => {
    bioContainer.querySelector('.js-bioContent').remove();
    html.classList.remove('scroll-lock');

    raf(() => {
        bioModal.classList.remove('-revealed');
        raf(() => {
            bioModal.classList.remove('-active');
        });
    });
});
